import React from "react";
import "./Loader.scss";
import { useRef, useEffect } from "react";
import { gsap, Power1, Expo } from "gsap";

function Loader() {
    const ref = useRef(null);
    let t1 = gsap.timeline();
    useEffect(() => {
        const element = ref.current;
        t1.from(".block", {
            duration: 1.5,
            width: "0%",
            ease: Power1.in,
            delay: 3,
            stagger: 0.04,
        });
        gsap.timeline().to(element.querySelector(".loader__text"), {
            duration: 1.5,
            x: 50,
            opacity: 0,
            ease: Expo.easeInOut,
            delay: 2.5,
        });
    }, []);

    return (
        <section>
            <div className="container" ref={ref}>
                <div className="loader__text">
                    Loading
                </div>
                <div className="overlay">
                    <div class="block block-1"></div>
                    <div class="block block-2"></div>
                    <div class="block block-3"></div>
                    <div class="block block-4"></div>
                    <div class="block block-5"></div>
                    <div class="block block-6"></div>
                    <div class="block block-7"></div>
                    <div class="block block-8"></div>
                    <div class="block block-9"></div>
                    <div class="block block-10"></div>
                    <div class="block block-11"></div>
                    <div class="block block-12"></div>
                    <div class="block block-13"></div>
                    <div class="block block-14"></div>
                    <div class="block block-15"></div>
                    <div class="block block-16"></div>
                    <div class="block block-17"></div>
                    <div class="block block-18"></div>
                    <div class="block block-19"></div>
                    <div class="block block-20"></div>
                </div>
            </div>

        </section>
    )
}

export default Loader;